// ------------ Nas Biz Advisory Website ------------
// ------------- PROD ------------------------
/* 
  firestore location: Singapore
*/

export const firebaseConfig = {
  // copy all these lines from "Add Firebase to your web app" setup guide.
  apiKey: "AIzaSyA-H2f0ZEat1AG3A4GkU2mpMQxvyu3mnJg",
  authDomain: "nasbizadvisory-web-prod-77f6f.firebaseapp.com",
  projectId: "nasbizadvisory-web-prod-77f6f",
  storageBucket: "nasbizadvisory-web-prod-77f6f.appspot.com",
  messagingSenderId: "374349739478",
  appId: "1:374349739478:web:88ab14b7d8ceb1b4362077",
  measurementId: "G-LKYLRXJL2L"
}


// standard system fields for email of new contact form:
export const client_id = "nasBizAdvisory_prod"
export const client_name = "Nas Biz Advisory Prod"
export const client_emails = ["andyliao@aria-it.com", "nas@nasbizadvisory.com"]